// extracted by mini-css-extract-plugin
export var header = "FlyoverUpsell-module__header___mFy0G";